import styled from "styled-components";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import { GET_RACE_INFO_LIST } from "@/app/utils/request/query";
import { getRaceInfoList } from "@/app/utils/request/requestList";
import Placing from "@/app/ui/Common/Placing";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { text_size } from "@/app/utils/MixinSize";
import GearInfo from "../GearInfo";
import _ from "lodash";
import { formattedNumber } from "@/app/utils/Common";
import { useMyContext } from "@/app/utils/MyContext";
import Loading from "@/app/ui/Common/Loading"; 
import VideoPlayerIconBlue from "@/app/ui/Common/SvgComponent/VideoPlayerIconBlue";
 

const Container = styled.div`
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #b4b4b4;
`;
const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 8px;
  background: white;
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 17px;
    text-align: left;
    color: black;
  }
`;
const HeaderExpand = styled.div<{ open: boolean }>`
  display: flex;
  align-items: center;
  height: 20px;
  border-left: 1px solid rgba(180, 180, 180, 1);
  padding-left: 16px;
  p {
    ${text_size(11)}
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.2652941048145294px;
    text-align: left;
    color: rgba(18, 44, 104, 1);
  }
  img {
    transform: rotate(${({ open }) => (open ? "-180deg" : "0deg")});
    margin-left: 6px;
  }
`;
const RecordContainer = styled.div<{ open: boolean }>`
  border-bottom: ${({ open }) =>
    open ? "none" : "1px solid rgba(180, 180, 180, 1);"};
  background: #e1e1e1;
  &:nth-last-of-type(1) {
    border-bottom: none;
    transition: all 0.4s ease;
    border-radius: ${({ open }) => (open ? "0" : "0 0 4px 4px")};
  }
`;
const RecordWrapper = styled.div`
  padding: 4px 0;
`;
const RecordItem = styled.div<{ open: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  padding: 0 16px;
  & .item_content {
    padding-left: 8px;
    display: flex;
    align-items: center;
    height: 28px;
    border-left: 1px solid rgba(180, 180, 180, 1);
    p {
      ${text_size(13)}
      font-weight: 500;
      line-height: 17px;
      text-align: left;
      color: rgba(51, 51, 51, 1);
    }
  }
  img {
    transform: rotate(${({ open }) => (open ? "-180deg" : "0deg")});
  }
`;
const MarginLeft24 = styled.div`
  margin-left: 24px;
`;
const RecordDetailWrapper = styled.div`
  padding: 16px 20px;
`;
const TitleText = styled.p`
  ${text_size(13)}
  font-weight: 300;
  line-height: 14px;
  text-align: left;
  color: rgba(18, 44, 104, 1);
  &.marginTop16 {
    margin-top: 16px;
  }
`;
const ContentText = styled.p`
  ${text_size(13)}
  font-weight: 500;
  line-height: 17px;
  text-align: left;
  color: rgba(51, 51, 51, 1);
  &.marginTop4 {
    margin-top: 4px;
  }
  .gearInfo {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    z-index: 999;
    pointer-events: auto;
    background: rgba(0, 0, 0, 0.5);
    align-items: center;
    justify-content: center;
  }
`;
const SplitDiv = styled.div`
  margin: 16px 0;
  height: 1px;
  width: 100%;
  background: rgba(180, 180, 180, 1);
`;
const WinnerSplit = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  & .split_line {
    margin-left: 10px;
    flex: 1;
    height: 1px;
    background: rgba(180, 180, 180, 1);
  }
`;
const WinnerInfo = styled.div`
  margin-top: 7.5px;
`;
const WinnerItem = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
`;
const FinishMargin = styled.div`
  display: flex;
  span {
    padding-top: 4px;
    ${text_size(13)}
    font-weight: 500;
    text-align: left;
    align-self: flex-end;
    color: rgba(51, 51, 51, 1);
  }
  p {
    margin-left: 4px;
    ${text_size(11)}
    font-weight: 500;
    text-align: left;
    right: 0;
    color: rgba(51, 51, 51, 1);
    align-self: flex-start;
  }
`;
const DivUnraced = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 0 0 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${text_size(13)}
  font-weight: 500;
  height: 150px;
  box-shadow: inset 0px 15px 10px -15px rgba(0, 0, 0, 0.1);
  padding: 0 16px;
`;

const FullFormM = (props: any) => {
  const { data, raceNo } = props;
  const { state: myContextState } = useMyContext();
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [raceInfoData, setRaceInfoData] = useState<any>([]);
  const [childStates, setChildStates] = useState([]);
  const [isCollapseAll, setCollapseAll] = useState(false);
  const [loading, setLoading] = useState(true);
 
  const OneBSwitch = window.globalConfig?.OneBSwitch;
  const TWO_A_SWITCH = globalConfig?.TwoASwitch;
  const showLastrunReplay = TWO_A_SWITCH ? (data?.videoLatestLastrun) : (OneBSwitch && props?.idx == 0 && data?.videoReplayLink);

  useEffect(() => {
    if (data) {
      getRaceInfoList(
        {
          ids: [data.id],
          meetingDate: data.id?.split("S")[0],
          raceNumber: `${raceNo}`,
        },
        GET_RACE_INFO_LIST,
        "qids"
      )
        .then((res: any) => {
          const formRecord = res.simulcastHorse[0].horseFormRecord;
          setRaceInfoData(formRecord);
          setChildStates(
            formRecord.map((_: any, index: any) => {
              if (index === 0) {
                return true;
              } else {
                return false;
              }
            })
          ); 
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => { 
          setLoading(false);
        });
    }
  }, [data]);
  const updateChildState = (index: any, newState: any) => {
    if (index === "collapse" || index === "expand") {
      setChildStates((prevStates: any) => {
        return prevStates.map(() => newState);
      });
    } else {
      setChildStates((prevStates: any) => {
        return prevStates.map((state: any, i: any) =>
          i === index ? newState : state
        );
      });
    }
  };
  useEffect(() => {
    if (childStates.every((item: any) => item === true)) {
      setCollapseAll(true);
    } else {
      setCollapseAll(false);
    }
  }, [childStates]);
  
  const RenderRecord = (props: any) => {
    const { open, setOpen, info, isLast } = props;
  
    const getDCG = (info: any) => {
      const distance = info?.distance;
      const cou =
        info?.raceTurn?.code && lang.langType === LANGTYPE_EN
          ? info.raceTurn?.code
          : info.raceTurn?.chinese;
      const going =
        info?.going?.code && lang.langType === LANGTYPE_EN
          ? info.going?.english
          : info.going?.chinese;
      const track =
            info?.track?.code && lang.langType === LANGTYPE_EN
                ? info?.track?.english
                : info?.track?.chinese;
        return `${distance}/${cou ?? info?.course?.code ?? "-"}/${going}/${track}`;
    };
    const getPosInRunning = (posInfo: any) => {
      let result = "-";
      let hasPos = false;
      if (posInfo?.length) {
        let posArr = [];
        posArr = posInfo?.map((item: any) => {
          if (item.ruPos !== -1) {
            hasPos = true;
            return item.ruPos;
          } else {
            return "-";
          }
        });
        result = posArr.join(" ");
      }
      return hasPos ? result : "-";
    };
    const [showGearLegend, setShowGearLegend] = useState(false);
    const handleClickGear = (e: any) => {
      e.stopPropagation();
      setShowGearLegend(true);
    };
    const handleLeaveGear = () => {
      setShowGearLegend(false);
    }; 
  
    const getConditionInfo = (info: any) => {
      const className = info.className?.code ? info.className?.code + " " : "";
      const raceName = info.raceName?.code ? lang.langType === LANGTYPE_EN ? info.raceName?.english + " " : info.raceName?.chinese + " " : "";
      const ageCondition = lang.langType === LANGTYPE_EN ? info.ageCondition?.english : info.ageCondition?.chinese;
      const condition = lang.langType === LANGTYPE_EN ? info.condition?.english : info.condition?.chinese;
      const currency = lang.langType === LANGTYPE_EN ? info.currency?.english : info.currency?.chinese;
      return`${className}${raceName}${ageCondition} ${condition} ${currency} ${info?.prizeMoney && formattedNumber(Number(info?.prizeMoney))}`
    }

    const getTrack = (info: any) => {
      const course = info.course?.code ? lang.langType === LANGTYPE_EN ? info.course?.code : info.course?.chinese : "-";
      const country = info.cntyShortNm?.code ? lang.langType === LANGTYPE_EN ? info.cntyShortNm?.english : info.cntyShortNm?.chinese : "-";
      return `${course}, ${country}`
    }

    const handleWinners =(wins: any, langType: string) => {
      let result = "";
      wins?.forEach((x: any) => {
        result =  lang.langType === LANGTYPE_EN ? `${result !="" ? result + ", " : ""}${x.name.english} (${x.cnty.english})` : `${result !="" ? result + "," : ""}${x.name.chinese} (${x.cnty.chinese})`;
        //result =  `${result} ${lang.langType === LANGTYPE_EN ? `${x.name.english} (${x.cnty.english})` : `${x.name.chinese} (${x.cnty.chinese})`}`; 
      })
      return result;
    }
    const displayVideoByDate = (data: any, date?: string): boolean => {
      const dateKey = date?.slice(0, 10).replaceAll("-", "");
      if (!dateKey) {
        return false;
      }
      const video = data?.["sim-lr-grouped"]?.[dateKey]?.[lang.langCode];
      return Boolean(video?.m || video?.s);
    };
    return (
      <RecordContainer id="horse_profile_mobile_full_form" open={open}>
        <RecordWrapper id="horse_profile_mobile_record_item">
          <RecordItem open={open}>
            <div style={{ position: "relative", width: OneBSwitch ? "94px" : "60px", minWidth: "60px" }}>
              <Placing
                placing={info.ruPlace}
                totalRunners={info.numOfStarters ? info.numOfStarters : 18}
                type="mobile"
              ></Placing> 
              {
                displayVideoByDate(data?.videos,info?.date) && <VideoPlayerIconBlue onClick={() => props?.onRunReplayItemClick(data,"EachRun", info?.date)} style={{position: "absolute", right: '8px', top: /^-?\d+$/.test(info.ruPlace) ? '3px' : '0', width:24, height:24}} />
              }  
            </div>
            <div className="item_content" style={{flex: OneBSwitch ? "1" : "unset"}}>
              <p>
                {formattedDate(toDate(info.date, dateFormat.qids.date), dateFormat.display.date)}
              </p>
              <MarginLeft24 />
              <p style={{ minWidth: "72px" }}>
                {getTrack(info)}
              </p>
            </div>
            <img
              onClick={() => setOpen(!open)}
              src={`${myContextState.assetPrefix}/race_card_expand_black.svg`}
            />
          </RecordItem>
        </RecordWrapper>
        <Collapse
          id="horse_profile_mobile_race_card_detail"
          sx={{
            background: "white",
            borderRadius: isLast ? "0 0 4px 4px" : "none",
          }}
          in={open}
        >
          <RecordDetailWrapper>
            <TitleText>{t("race_card_detail")}</TitleText>
            <ContentText className="marginTop4"> 
                {getConditionInfo(info)} 
            </ContentText>
            <TitleText className="marginTop16">{t("race_card_DCG")}</TitleText>
            <ContentText className="marginTop4">{getDCG(info)}</ContentText>
            <SplitDiv />
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TitleText>{t("race_card_WT")}</TitleText>
                <ContentText className="marginTop4">
                  {info.actualWeight ? info.actualWeight : "-"}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_jockey")}</TitleText>
                <ContentText className="marginTop4">
                  {info.jockey?.code
                    ? lang.langType === LANGTYPE_EN
                      ? info.jockey?.name_en
                      : info.jockey?.name_ch
                    : "-"}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_Dr")}</TitleText>
                <ContentText className="marginTop4">
                  {info.barrierDrNo && Number(info.barrierDrNo) > 0
                    ? info.barrierDrNo
                    : "-"}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_race_time")}</TitleText>
                <ContentText className="marginTop4">
                  {info.finalTimeOfRace
                    ? info.finalTimeOfRace
                    : "-"}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_position")}</TitleText>
                <ContentText className="marginTop4">
                  {getPosInRunning(info.sectionInfos)}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_finish_margin")}</TitleText>
                <ContentText className="marginTop4">
                  <FinishMargin>
                    <span>{info.placeNo ? info.placeNo : "-"}</span>
                    <p>
                    {lang.langType === LANGTYPE_EN ?
                      info.marginOrLBW?.english ? info.marginOrLBW?.english : "-"
                      : 
                      info.marginOrLBW?.chinese ? info.marginOrLBW?.chinese : "-"}
                    </p>
                  </FinishMargin>
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_odds")}</TitleText>
                <ContentText className="marginTop4">
                  {info.winOdds ? info.winOdds + (info.fav ? `(${info.fav})` : "") : "-"}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_gear")}</TitleText>
                <ContentText
                  className="marginTop4"
                  style={{ position: "relative" }} 
                >
                  <span
                    onClick={handleClickGear} 
                  >
                    {info.gear ? info.gear : "-"}
                  </span>
                  {showGearLegend && props?.gearData?.length > 0 && (
                    <div className="gearInfo" onClick={() => setShowGearLegend(false)}>
                      <GearInfo
                        gear={info.gear}
                        gearData={props.gearData}
                        type="mobile"
                      ></GearInfo>
                    </div>
                  )}
                </ContentText>
              </Grid>
              <Grid item xs={4}>
                <TitleText>{t("race_card_med")}</TitleText>
                <ContentText className="marginTop4">
                  {lang.langType === LANGTYPE_EN
                    ? info.med?.english
                      ? info.med?.english
                      : "-"
                    : info.med?.chinese
                    ? info.med?.chinese
                    : "-"}
                </ContentText>
              </Grid>
            </Grid>
            <WinnerSplit>
              <img src={`${myContextState.assetPrefix}/race_card_winner.svg`} />
              <div className="split_line" />
            </WinnerSplit>
            <WinnerInfo>
              <WinnerItem>
                <TitleText style={{ width: "66px" }}>
                  {t("race_card_W")}
                </TitleText>
                <ContentText>
                  {info.winners?.filter((x: any) => x.pos == 1)?.length > 0 ?
                   handleWinners(info.winners?.filter((x: any) => x.pos == 1), lang.langType) 
                  : "-"} 
                </ContentText>
              </WinnerItem>
              <WinnerItem>
                <TitleText style={{ width: "66px" }}>
                  {t("race_card_S")}
                </TitleText>
                <ContentText>
                  {info.winners?.filter((x: any) => x.pos == 2)?.length > 0 ?
                   handleWinners(info.winners?.filter((x: any) => x.pos == 2), lang.langType) 
                  : "-"} 
                </ContentText>
              </WinnerItem>
              <WinnerItem>
                <TitleText style={{ width: "66px" }}>
                  {t("race_card_T")}
                </TitleText>
                <ContentText>
                  {info.winners?.filter((x: any) => x.pos == 3)?.length > 0 ?
                   handleWinners(info.winners?.filter((x: any) => x.pos == 3), lang.langType) 
                  : "-"} 
                </ContentText>
              </WinnerItem>
            </WinnerInfo>
          </RecordDetailWrapper>
        </Collapse>
      </RecordContainer>
    );
  };

  return (
    <>
    {loading? <Loading />: null}
    <Container style={{ display: loading ? "none" : ""}}>
      <HeaderWrapper>
        <p>{t("race_card_record")}</p>
        <HeaderExpand
          onClick={() => {
            const str: any = isCollapseAll ? "expand" : "collapse";
            const bool: any = str === "collapse" ? true : false;
            updateChildState(str, bool);
            setCollapseAll(!isCollapseAll);
          }}
          open={isCollapseAll}
        >
          <p>{isCollapseAll ? t("collapse_all") : t("expand_all")}</p>
          <img src={`${myContextState.assetPrefix}/race_card_expand.svg`} />
        </HeaderExpand>
      </HeaderWrapper>
      {props.totalRun >= 0 ?
      raceInfoData?.length > 0 ? (
        raceInfoData?.map((item: any, index: any) => {
          if (index === raceInfoData.length - 1) {
            return (
              <RenderRecord
                idx={index}
                key={index}
                info={item}
                gearData={props.gearData}
                isLast={true}
                open={childStates[index]}
                setOpen={(newState: any) => updateChildState(index, newState)}
                onRunReplayItemClick={props?.onRunReplayItemClick}
                onBarrierTrialItemClick={props?.onBarrierTrialItemClick}
              />
            );
          } else {
            return (
              <RenderRecord
                idx={index}
                key={index}
                info={item}
                gearData={props.gearData}
                open={childStates[index]}
                setOpen={(newState: any) => updateChildState(index, newState)}
                onRunReplayItemClick={props?.onRunReplayItemClick}
                onBarrierTrialItemClick={props?.onBarrierTrialItemClick}
              />
            );
          }
        })
      ) : (
        <DivUnraced>{t("unraced")}</DivUnraced>
      ) : (<DivUnraced>{t("unavailable")}</DivUnraced>)
    }
    </Container>
    </>
  );
};
export default FullFormM;
